<template>
  <div>
    <keypad
      :username = "username"
      :number = "transferNumber"
      :digit = "transferDigit"
      :clear = "transferClear"
      :backspace = "transferBackspace"
      >
    </keypad>
    <div class="row phone-row" style="margin: 0 auto 11px auto !important;">
      <div class="col-2 offset-1">
        <b-button variant="primary" @click="cancelTransfer">
          <i class="mdi mdi-arrow-left"></i>
        </b-button>
      </div>
      <div class="col-4 offset-1">
        <b-button variant="success" @click="attendedTransferCall(call.currentCall.params.remote_caller_id_name, call.currentCall.params.callID, transferNumber, call.name)">
          {{ $t('transfer.attended') }}
        </b-button>
      </div>
      <div class="col-4">
        <b-button style="width: 100%;" variant="success" @click="transferCall">
          {{ $t('transfer.blind') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import keypad from './Keypad'

export default {
  name: 'transfer',
  components: {
    keypad
  },
  props: {
    username: {
      type: String,
      required: true
    },
    call: {
      type: Object
    },
    transferNumber: {
      type: String,
      default: ''
    },
    transferDigit: {
      type: Function
    },
    transferClear: {
      type: Function
    },
    transferBackspace: {
      type: Function
    },
    cancelTransfer: {
      type: Function
    },
    transferCall: {
      type: Function
    },
    attendedTransferCall: {
      type: Function
    }
  }
}
</script>

<style scoped>

.btn.btn-rounded {
  border-radius: 10px;
  color: #ffffff;
  width: 100%;
  height: 42px;
  cursor: pointer;
}

.phone-row {
  margin: 20px auto !important;
  max-width: 320px !important;
  clear: both !important;
  text-align: center !important;
  font-family: 'Exo' !important;
}

.phone-btn {
  min-width: 108px;
  padding: 0.7rem 0.2rem;
}

</style>
